import { useWorkspaceToolsSync } from "./root/useWorkspaceToolsSync";
import { WorkspaceToolsErrorModal } from "./root/WorkspaceToolsErrorModal";
import { WorkspaceToolsReloadConfirm } from "./root/WorkspaceToolsReloadConfirm";

export const WorkspaceToolsRoot = () => {
	useWorkspaceToolsSync();

	return (
		<>
			<WorkspaceToolsErrorModal />
			<WorkspaceToolsReloadConfirm />
		</>
	);
};
